import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import settings_45global from "/vercel/path0/middleware/settings.global.ts";
export const globalMiddleware = [
  validate,
  settings_45global
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/middleware/auth.ts")
}